"use strict";

var _interopRequireDefault = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cancelForespeak = cancelForespeak;
exports.cancelForespeakBatch = cancelForespeakBatch;
exports.checkVesselComplete = checkVesselComplete;
exports.doForespeakPH = doForespeakPH;
exports.getBookedBl = getBookedBl;
exports.getForespeakAction = getForespeakAction;
exports.getInitialData4PH = getInitialData4PH;
exports.querySysAccountPort = querySysAccountPort;
exports.saveDemurrageBills = saveDemurrageBills;
exports.saveForespeak = saveForespeak;
exports.saveForespeakPH = saveForespeakPH;
exports.search = search;
exports.searchContainer = searchContainer;
exports.searchFreight = searchFreight;
var _request = _interopRequireDefault(require("@/utils/request"));
//查询港口权限
function querySysAccountPort() {
  return (0, _request.default)({
    url: "/sitceb-system-service/ebSysAccount/querySysAccountPort",
    method: 'post'
  });
}
//查询预约信息
function search(data) {
  return (0, _request.default)({
    url: "/ebusiness/edoCredit/search",
    method: 'post',
    data: data
  });
}
// 查询已经被预约的记录
function getBookedBl(data) {
  return (0, _request.default)({
    url: "/ebusiness/edoCredit2/getBookedBl",
    method: 'post',
    data: data
  });
}
//查询费用信息
function searchFreight(data) {
  return (0, _request.default)({
    url: "/ebusiness/edoCredit/searchFreight",
    method: 'post',
    data: data
  });
}
//换单预约-弹窗查询
function getForespeakAction(edoCreditId, portCode) {
  return (0, _request.default)({
    url: "/ebusiness/edoCredit/getForespeakAction/".concat(edoCreditId, "?portCode=") + portCode,
    method: 'get'
  });
}
function getInitialData4PH(data) {
  return (0, _request.default)({
    url: "/ebusiness/edoCredit/getInitialData4PH",
    method: 'post',
    data: data
  });
}

//PH查询所有的箱信息
function searchContainer(data) {
  return (0, _request.default)({
    url: "/ebusiness/edoCredit/searchContainer",
    method: 'post',
    data: data
  });
}
//doForespeakPH
function doForespeakPH(data) {
  return (0, _request.default)({
    url: "/ebusiness/edoCredit/doForespeakPH",
    method: 'post',
    data: data
  });
}
function saveDemurrageBills(data) {
  return (0, _request.default)({
    url: "/ebusiness/edoCredit/saveDemurrageBills",
    method: 'post',
    data: data
  });
}
//换单预约-宁波、新港、青岛
function saveForespeak(data) {
  return (0, _request.default)({
    url: "/ebusiness/edoCredit/saveForespeak",
    method: 'post',
    data: data
  });
}
function saveForespeakPH(data) {
  return (0, _request.default)({
    url: "/ebusiness/edoCredit/saveForespeakPH",
    method: 'post',
    data: data
  });
}
//换单预约-取消
function cancelForespeak(edoCreditId) {
  return (0, _request.default)({
    url: "/ebusiness/edoCredit/cancelForespeak/".concat(edoCreditId),
    method: 'get'
  });
}
// 换单预约历史-批量取消预约
function cancelForespeakBatch(data) {
  return (0, _request.default)({
    url: "/ebusiness/edoCredit/cancelForespeakBatch",
    method: 'post',
    data: data
  });
}
// 完船确认校验
function checkVesselComplete(data) {
  return (0, _request.default)({
    url: "/ebusiness/edoCredit/checkVesselComplete",
    method: 'post',
    data: data
  });
}